export default __webpack_public_path__ + "static/media/approve-failed.8c2ae017.svg";